/* eslint-disable react/prop-types */
import React, { useContext } from "react";

import "./ListPage.css";
import BookmarkIcon from "../../img/svg/Bookmark.svg";
import { readCookie } from "../../handleCookieData";
import MainWrapper from "../../modules/Slider/MainWrapper";
import ListComponent from "../../modules/ListComponent/ListComponent";

function ListPage(props) {
  const [count, setCount] = React.useState(0);

  const { onlyShowPublicProjects } = props;

  return (
    <div className="favouriten-liste-wrapper">
      {readCookie("list_cookie").toString().length > 1 ? (
        <h1 className="headline">Meine Liste</h1>
      ) : null}
      <MainWrapper>
        {readCookie("list_cookie").toString().length > 1 ? (
          <ListComponent
            key={onlyShowPublicProjects}
            sliderHeadline="Mag ich"
            contentType={`resolveParams?nur_oeffentlich=${
              onlyShowPublicProjects ? 1 : 0
            }`}
            recentlyViewed={readCookie("list_cookie")}
            displayListButtons={false}
            requestFullAPI={false}
            listPageCallback={() => setCount(count + 1)}
            onListPage
          />
        ) : (
          <>
            <h1 style={{ color: "white" }}>
              Es befinden sich aktuell keine Projekte in deiner Liste.
            </h1>
            <h3 style={{ color: "white" }}>
              Du kannst Projekte über dieses Icon zur Liste hinzufügen.
            </h3>
            <img
              src={BookmarkIcon}
              className="bookmark-icon"
              alt="Zu meiner Liste hinzufügen"
            />
          </>
        )}
      </MainWrapper>
    </div>
  );
}

export default ListPage;
